"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBindingConstraintsWithServiceId = isBindingConstraintsWithServiceId;
function isBindingConstraintsWithServiceId(serviceId) {
    return (constraints) => constraints.serviceIdentifier === serviceId;
}
//# sourceMappingURL=isBindingConstraintsWithServiceId.js.map